import { render, staticRenderFns } from "./ion.vue?vue&type=template&id=357f1862&"
import script from "./ion.vue?vue&type=script&lang=js&"
export * from "./ion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports